import script from "./ImageBlockWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageBlockWidget.vue?vue&type=script&setup=true&lang=js"

import "./ImageBlockWidget.vue?vue&type=style&index=0&id=7289b774&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7289b774"]])

export default __exports__